import { isLocale, type Locale } from '@/lib/i18n-routes';

export const PREFERRED_LANGUAGE_COOKIE = 'fd_pref_lang';
export const PREFERRED_LANGUAGE_COOKIE_OPTIONS = {
  path: '/',
  maxAge: 365 * 24 * 60 * 60,
  sameSite: 'lax',
  httpOnly: false,
} as const;

export function parsePreferredLanguage(
  value: string | undefined | null,
): Locale | null {
  return value && isLocale(value) ? value : null;
}
